<template>
  <div>
    <vs-table
      stripe
      search
      :sst="true"
      @search="handleSearch"
      :data="items.routes"
      multiple
      v-model="selected"
    >
      <template slot="header">
        <vs-row style="margin-bottom:20px;">
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
            <div style="width:250px;display:inline-block;margin-right:10px;">
              <label class="vs-input--label">Zone</label>
              <v-select
                v-model="zone_id"
                :clearable="false"
                :options="zones"
                :reduce="el => el.id" label="name"  />
            </div>
          </vs-col>
        </vs-row>
      </template>

      <template slot="thead">
        <vs-th>
          Name
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="item.id" :key="item.id" v-for="item in data">
          <vs-td>
            {{item.name}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="mt-3 mb-3" v-if="page">
      <pagination :last-page="items.pagination.pages" v-model="page" />
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState} from "vuex";

  export default {
    name: "Routes",
    props: {
      value: {
        type: Array,
        required: true
      }
    },
    data(){
      return {
        page: 1,
        search: null,
        items: {
          routes: [],
          pagination: {
            page: 1,
            limit: 10,
            total: 0,
            pages: 0,
            prev: null,
            next: null
          }
        },
        zone_id:null,
        selected: []
      }
    },
    computed: {
      ...mapState(['partner_namespace']),
      ...mapState('zones',['zones'])
    },
    watch : {
      page(newVal, oldVal){
        if(newVal !== oldVal){
          this.getItems(this.search);
        }
      },
      selected(newVal, oldVal){
        this.$emit('input', newVal);
      },
      zone_id(newVal, oldVal){
        if(newVal !== oldVal){
          this.getItems(this.search);
        }
      },
    },
    created () {
     this.initData();
      this.doSearch = _.debounce(this.getItems,300);
    },
    methods: {
      ...mapActions('routes',['getRoutes']),
      initData(){
        if(this.zones.length > 0){
          this.zone_id = this.zones[0].id;
        }
      },
      getItems(search){

        if(this.page > 1 && this.page > this.items.pagination.pages){
          this.page = this.items.pagination.pages;
        }
        let payload = {
          page: this.page,
        };
        if(search){
          payload.search = search;
        }
        if(this.zone_id){
          payload.zone_id = this.zone_id;
        }
        this.getRoutes(payload)
          .then(data=>{
            this.items = data;
          })
          .catch(error=>{

          })
      },
      handleSearch(searching){
        this.page = 1;
        this.search = searching === '' ? null : searching;
        this.doSearch(searching);
      },
    }
  }
</script>

<style scoped>

</style>
